import 'react-native-gesture-handler';
import React, { useEffect } from 'react';
import { AccessibilityInfo } from 'react-native';
import { SafeAreaProvider } from 'react-native-safe-area-context';
import { NavigationContainer } from '@react-navigation/native';
import { AppNavigator } from './src/navigation/AppNavigator';
import { initializeAccessibilityFromSystem, useAccessibilityStore } from './src/store/useAccessibilityStore';
import { OfflineBanner } from './src/components/OfflineBanner';

function App(): React.JSX.Element {
  useEffect(() => {
    // Sync accessibility preferences from system settings on startup.
    initializeAccessibilityFromSystem();

    // Listen for system "Reduce Motion" changes and update the store.
    const reduceMotionSubscription = AccessibilityInfo.addEventListener(
      'reduceMotionChanged',
      (enabled: boolean) => {
        useAccessibilityStore.getState().setReduceMotion(enabled);
      },
    );

    return () => {
      reduceMotionSubscription.remove();
    };
  }, []);

  return (
    <SafeAreaProvider>
      <NavigationContainer>
        <AppNavigator />
        <OfflineBanner />
      </NavigationContainer>
    </SafeAreaProvider>
  );
}

export default App;
